/** 表示・検索専用。UUIDやDBの整数番号を置き換えない。 */
export type PublicPersonKind = "M" | "S";
const MAX_NUMBER = 2_147_483_647;

export function formatPublicPersonId(
  kind: PublicPersonKind,
  number: number | null | undefined
): string | null {
  if (
    typeof number !== "number" ||
    !Number.isInteger(number) ||
    number < 1 ||
    number > MAX_NUMBER
  )
    return null;
  return `${kind}-${String(number).padStart(6, "0")}`;
}

/** 異なる種別のプレフィックスは拒否する。旧数字形式も引き続き受け付ける。 */
export function parsePublicPersonId(
  value: string,
  kind: PublicPersonKind
): number | null {
  const match = new RegExp(`^(?:${kind}-)?(\\d+)$`, "i").exec(value.trim());
  if (!match) return null;
  const number = Number(match[1]);
  return Number.isInteger(number) && number > 0 && number <= MAX_NUMBER
    ? number
    : null;
}
